import React, { useEffect } from 'react';
import { visitingFacultyList } from '../../ProData';
import { Helmet } from "react-helmet-async";
import { Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';

export default function TeamContent() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="py-5" style={{ background: '#f8fafc', minHeight: '85vh' }}>
      <Helmet>
        <title>Visiting Faculty - Vidyajyoti College of Theology</title>
        <meta name="description" content="Meet our distinguished visiting professors, guest lecturers, and adjunct theological scholars at Vidyajyoti." />
        <meta name="keywords" content="Visiting Faculty, Guest Lecturers, Theology professors Delhi, Vidyajyoti visiting professors" />
        <link rel="canonical" href="/about/visitingFaculty" />
      </Helmet>

      <div className="container">
        {/* Page Header */}
        <div className="text-center mx-auto pb-4" style={{ maxWidth: '750px' }}>
          <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-3" style={{ background: 'rgba(26, 43, 86, 0.08)', color: '#1a2b56', fontSize: '0.85rem', fontWeight: 600, border: '1px solid rgba(26, 43, 86, 0.2)' }}>
            <Sparkles size={14} /> Academic Excellence
          </div>
          <h1 className="display-6 fw-bold mb-3" style={{ color: '#1a2b56', fontFamily: "'Outfit', sans-serif" }}>
            Visiting Faculty
          </h1>
          <p className="lead text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
            Eminent scholars, researchers, and specialized guest professors from universities across India and abroad who contribute to our modular and elective theological courses.
          </p>
        </div>

        {/* Visiting Faculty Grid */}
        <div className="row g-4 justify-content-center">
          {visitingFacultyList && visitingFacultyList.map((item, index) => (
            <motion.div
              key={index}
              className="col-sm-6 col-md-4 col-lg-3"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05 }}
            >
              <div
                className="card h-100 border-0 shadow-sm rounded-4 p-4 text-center bg-white d-flex flex-column align-items-center"
                style={{
                  borderTop: '4px solid #79031d',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-6px)';
                  e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.06)';
                }}
              >
                {/* Circular Avatar */}
                <div
                  className="rounded-circle p-1 mb-3 shadow-sm"
                  style={{
                    background: 'linear-gradient(135deg, #79031d 0%, #c69214 100%)',
                    width: '130px',
                    height: '130px'
                  }}
                >
                  <img
                    src={item.avatarSrc}
                    alt={item.name}
                    className="rounded-circle w-100 h-100"
                    style={{ objectFit: 'cover' }}
                  />
                </div>

                <h4 className="fw-bold mb-1" style={{ color: '#1a2b56', fontSize: '1.1rem' }}>
                  {item.name}
                </h4>

                <p className="text-muted small mb-0 mt-1" style={{ lineHeight: '1.4' }}>
                  <span className="badge px-2 py-0.5 rounded-pill bg-light text-dark border">
                    {item.subject || 'Visiting Professor'}
                  </span>
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
